import { getShopifyCollectionByHandle } from 'lib/amplify';
import { CGCollection } from 'types/shopify';
import { serverErrorMessage } from 'utilities/constants';
import { useQuery } from 'react-query';

interface CollectionHookError {
  message: string;
}

interface CollectionHookResult {
  collection: CGCollection | undefined;
  error: CollectionHookError | undefined;
}

const getCollection = (handle: string | undefined) => async () => {
  if (!handle) {
    return undefined;
  }
  const collection: CGCollection | undefined = await getShopifyCollectionByHandle(handle);
  return collection;
};

// The queryKey is used to identify the request in the react-query cache.
const queryKey = (handle: string | undefined) => ['collection', handle];

export const useCollection = (handle: string | undefined): CollectionHookResult => {
  const { data, error } = useQuery(queryKey(handle), getCollection(handle));
  const errorObj = error ? { message: (error as Error).message || serverErrorMessage } : undefined;
  return { collection: data, error: errorObj };
};
